import React, {useState} from "react";
import {loginAccount} from "../../../api/accountApi";
import {useTranslation} from "react-i18next";
import {MessageType} from "../../components/MessageBox";
import {useAccount} from "../../../hooks/AccountContext";

interface LoginFormProps {
    setMessage: (message: MessageType) => void;
    onSuccess: () => void;
}

export default function LoginForm({
                                      setMessage,
                                      onSuccess
                                  }: LoginFormProps) {
    const {t} = useTranslation();

    const [form, setForm] = useState({username: "", password: ""});

    const isValid = form.username.trim() !== "" && form.password.trim() !== "";

    const {
        setAccount,
        reloadAccountData
    } = useAccount();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!isValid) return;

        try {
            const accountObj = await loginAccount(form);
            if (accountObj) {
                setAccount(accountObj);
                await reloadAccountData(accountObj);
                localStorage.setItem("account", JSON.stringify(accountObj));
                onSuccess();
            } else {
                setMessage({type: "error", text: t("auth.messages.loginError")});
            }
        } catch (err: any) {
            setMessage({type: "error", text: t("auth.messages.loginError")});
        }
    };

    return (
        <form onSubmit={handleSubmit} className="form-container auth-form" autoComplete="on">
            <div className="form-group">
                <label>{t("auth.fields.username")}</label>
                <input
                    type="text"
                    autoComplete="username"
                    value={form.username}
                    onChange={(e) => setForm({...form, username: e.target.value})}
                    className="form-input"
                    required
                />
            </div>

            <div className="form-group">
                <label>{t("auth.fields.password")}</label>
                <input
                    type="password"
                    autoComplete="current-password"
                    value={form.password}
                    onChange={(e) => setForm({...form, password: e.target.value})}
                    className="form-input"
                    required
                />
            </div>

            <button type="submit" className="form-button" disabled={!isValid}>
                {t("auth.actions.login")}
            </button>
        </form>
    );
}